import React from 'react'
import loadingAnim from 'assets/lotties/animation_lnvswuh2.json'
import Lottie from 'react-lottie'

function Loading() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingAnim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <div className='w-screen h-screen flex flex-col justify-center items-center'>
      <Lottie 
        options={defaultOptions}
          height={100}
          width={100}
        />
        <span className='text-primary -mt-4 ml-2 uppercase'>Loading...</span>
    </div>
  )
}

export default Loading